import * as React from 'react';
import type { Facet } from '../../Search/Facet.csharp';
import type { SelectedFacet } from '../../Search/SelectedFacet.csharp';
import { Button } from '../Button/Button';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import styles from './SelectedFiltersList.module.css';

interface SelectedFiltersListProps {
    facets: Facet[];
    selectedFacets: SelectedFacet[];
    onRemoveFacet: (selectedFacets: SelectedFacet[]) => void;
    removeFilterDescription: string;
}

const removeFilter = (
    facet: { id: string; value: string },
    selectedFacets: SelectedFacet[],
    onRemoveFacet: (selectedFacets: SelectedFacet[]) => void
) => {
    const selectedFacet = selectedFacets.find(facetType => facetType.id === facet.id);

    if (selectedFacet) {
        const index = selectedFacet.values.indexOf(facet.value);

        if (index >= 0) {
            selectedFacet.values.splice(index, 1);
        }
    }

    onRemoveFacet(selectedFacets);
};

const getLabelForFacet = (facetValue: string, facetId: string, facets: Facet[]) => {
    const selectedFacet = facets.find(facet => facet.id === facetId);

    if (selectedFacet) {
        const facetVal = selectedFacet.options.find(facet => facet.id === facetValue);

        return facetVal && facetVal.label;
    }
};

export const SelectedFiltersList: React.FC<React.PropsWithChildren<SelectedFiltersListProps>> = ({
    selectedFacets,
    onRemoveFacet,
    removeFilterDescription,
    facets,
}) => {
    const visibleFacets = selectedFacets
        .filter(sf => facets.some(f => f.id === sf.id))
        .map(selectedFacet =>
            selectedFacet.values.map(v => ({
                value: v,
                id: selectedFacet.id,
                label: getLabelForFacet(v, selectedFacet.id, facets),
            }))
        )
        .reduce((previousValue, currentValue) => [...previousValue, ...currentValue], []);

    return (
        <ul className={styles.SelectedFiltersList}>
            {visibleFacets.length > 0 &&
                visibleFacets.map(facet => (
                    <li className={styles.Item} key={facet.value}>
                        <span className={styles.FilterValue}>{facet.label || facet.value}</span>
                        <Button
                            onClick={() => removeFilter(facet, selectedFacets, onRemoveFacet)}
                            className={styles.IconRemove}
                        >
                            <SvgIcon iconName="close" />
                            <span className="visuallyHidden">{removeFilterDescription}</span>
                        </Button>
                    </li>
                ))}
        </ul>
    );
};
